import { Link } from 'react-router-dom';
import styles from './BlogCard.module.css';
import { getCategoryColor } from '../../data/blogPosts';

const BlogCard = ({ post, featured = false }) => {
  const categoryColors = getCategoryColor(post.category);

  return (
    <Link
      to={`/blog/${post.slug}`}
      className={`${styles.card} ${featured ? styles.featured : ''}`}
    >
      {/* ── Colored header band ── */}
      <div className={styles.cardHeader}>
        <span
          className={styles.categoryBadge}
          style={{ background: categoryColors.bg, color: categoryColors.text }}
        >
          {post.category}
        </span>
        <span className={styles.readingTime}>{post.readingTime}</span>
      </div>

      {/* ── Card body ── */}
      <div className={styles.cardBody}>
        <h3 className={styles.title}>{post.title}</h3>
        <p className={styles.excerpt}>{post.excerpt}</p>
      </div>

      {/* ── Card footer: author + date ── */}
      <div className={styles.cardFooter}>
        <div className={styles.author}>
          <div
            className={styles.avatar}
            style={{ background: `${post.author.color}22`, color: post.author.color }}
          >
            {post.author.initials}
          </div>
          <div className={styles.authorInfo}>
            <span className={styles.authorName}>{post.author.name}</span>
            <span className={styles.authorMeta}>{post.author.field}</span>
          </div>
        </div>
        <time className={styles.date} dateTime={post.date}>{post.date}</time>
      </div>
    </Link>
  );
};

export default BlogCard;
